// === Zod schemas: distributors ===
// Ported from PHP Click2Gro: DistributorModel / distributors table (admin/global)
// Same contact/address structure as fertilzer_companies.

import { z } from 'zod';

export const DistributorSchema = z.object({
  id:                z.number().int().positive(),
  company:           z.string().max(255).nullable(),
  client_id:         z.number().int().nullable(),
  invoice_prefix:    z.string().max(50).nullable(),
  status:            z.string().max(20).nullable(),
  registration_date: z.string().nullable(),
  street:            z.string().max(255).nullable(),
  suburb:            z.string().max(150).nullable(),
  postcode:          z.string().max(20).nullable(),
  state:             z.string().max(50).nullable(),
  country:           z.string().max(100).nullable(),
  phone_no:          z.string().max(50).nullable(),
  mobile_number:     z.string().max(50).nullable(),
  abn:               z.string().max(100).nullable(),
  division:          z.string().max(100).nullable(),
  title:             z.string().max(50).nullable(),
  first_name:        z.string().max(100).nullable(),
  last_name:         z.string().max(100).nullable(),
  email_address:     z.string().max(255).nullable(),
  web_link:          z.string().max(255).nullable(),
  created_by:        z.string().max(100).nullable(),
  updated_by:        z.string().max(100).nullable(),
  created_at:        z.string().datetime({ offset: true }).nullable(),
  updated_at:        z.string().datetime({ offset: true }).nullable(),
  deleted_at:        z.string().datetime({ offset: true }).nullable(),
});

export const DistributorInsertSchema = DistributorSchema.omit({
  id:         true,
  created_at: true,
  updated_at: true,
  deleted_at: true,
}).partial({
  client_id:         true,
  invoice_prefix:    true,
  status:            true,
  registration_date: true,
  street:            true,
  suburb:            true,
  postcode:          true,
  state:             true,
  country:           true,
  phone_no:          true,
  mobile_number:     true,
  abn:               true,
  division:          true,
  title:             true,
  first_name:        true,
  last_name:         true,
  email_address:     true,
  web_link:          true,
  created_by:        true,
  updated_by:        true,
});

export const DistributorUpdateSchema = DistributorInsertSchema.partial();

export type Distributor       = z.infer<typeof DistributorSchema>;
export type DistributorInsert = z.infer<typeof DistributorInsertSchema>;
export type DistributorUpdate = z.infer<typeof DistributorUpdateSchema>;
